import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

import { Icon } from '../Icon';
import styles from './AddToCartButton.module.scss';

type Props = {
  min?: number;
  max?: number;
  value: number;
  onChange?: (value: number) => void;
  onIncrease?: (value: number) => void;
  onDecrease?: (value: number) => void;
  size?: 'S' | 'M';
} & Pick<HTMLAttributes<HTMLElement>, 'className'>;

export const AddToCartButton = ({
  min = 1,
  max = 1000,
  onChange,
  onIncrease,
  onDecrease,
  value,
  size = 'M',
  className,
}: Props) => {
  const handleIncrease = () => {
    const next = Math.min(value + 1, max);
    onChange?.(next);
    onIncrease?.(next);
  };

  const handleDecrease = () => {
    const next = Math.max(value - 1, min);
    onChange?.(next);
    onDecrease?.(next);
  };

  if (value <= 0) {
    return (
      <div
        onClick={() => {
          const start = Math.max(min, 1);
          onChange?.(start);
          onIncrease?.(start);
        }}
        className={classNames(styles.containerSingleButton, className, {
          [styles.small]: size === 'S',
        })}
      >
        <button type="button" className={styles.button}>
          <Icon width={24} height={24} name="outlinedPlus" />
        </button>
      </div>
    );
  }

  return (
    <div
      className={classNames(styles.container, className, {
        [styles.small]: size === 'S',
      })}
    >
      <button
        type="button"
        disabled={value <= min}
        className={styles.button}
        onClick={handleDecrease}
      >
        <Icon width={24} height={24} name="outlinedMinus" />
      </button>
      <span className={styles.value}>{value}</span>
      <button
        type="button"
        disabled={value >= max}
        className={styles.button}
        onClick={handleIncrease}
      >
        <Icon width={24} height={24} name="outlinedPlus" />
      </button>
    </div>
  );
};
